import axios from "axios";

const BASE_API_URL = "/api/v1";

async function getVideoCategories() {
  try {
    const response = await axios.get(`${BASE_API_URL}/videoCategory/`, {
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching video categories:", error);
    throw new Error(
      error.response?.data?.message || "Failed to fetch video categories."
    );
  }
}

async function getVideoCategoryById(id) {
  try {
    const response = await axios.get(`${BASE_API_URL}/videoCategory/${id}/`, {
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
    console.error(`Error fetching video category with id ${id}:`, error);
    throw new Error(
      error.response?.data?.message ||
        `Failed to fetch video category with id ${id}.`
    );
  }
}

export { getVideoCategories, getVideoCategoryById };
